class Notification {
    /**
     * Constructor of the Notification object
     */
    constructor() {

    }

    /**
     * This function populate a toast message (Notifications box) for the user to see.
     *
     * @param title
     * @param message
     * @param type
     * @param delay
     */
    static message(title, message, type, delay = null) {
        if (typeof toastr !== 'undefined') {
            if (type === 'danger') {
                toastr.error(message, title);
            } else {
                toastr[type](message, title);
            }
        } else {
            try {
                let duration = 2000;
                if (type === 'danger') {
                    duration = null;
                }
                let id = Math.random().toString(16).slice(2);

                let temp = "data-bs-config='{\"autohide\": false, \"delay\": 5000}'";
                if (delay !== null && !isNaN(delay)) {
                    temp = "data-bs-config='{\"autohide\": true, \"delay\": " + delay + "}'";
                }

                $('.toast-dynamic').append(`
                    <div class="toast mb-3 toast-auto-${id}" ${temp} role="alert" aria-live="assertive" aria-atomic="true">
                        <div class="toast-header">
                            <strong class="me-auto text-${type}">${title}</strong>
                            <small class="text-muted">Just now</small>
                            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                        </div>
                        <div class="toast-body">
                            ${message}
                        </div>
                    </div>
                `);

                let toastLive = $(`.toast-auto-${id}`)

                let toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive)
                toastBootstrap.show()
            } catch (e) {
            }
        }
    }
}

export default Notification;
